export default function formatIso(iso) {
  if (!iso) return '';
  try {
    const d = new Date(String(iso).split('T')[0]);
    return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch (e) {
    return String(iso).split('T')[0] || '';
  }
}
